import React, { useState } from "react";

import type { RowData } from "@tanstack/react-table-v9";

import TableV2IconButton from "./TableV2IconButton";
import DropDown from "../../DropDown/DropDown";
import { Toast } from "../../Toast/Toast";
import { exportTable } from "../export/exportTable";
import type { ExportFormat, TableV2ExportOptions } from "../export/exportTable";
import type { TableV2Instance } from "../hooks/useTableV2";

const FORMATS: { format: ExportFormat; label: string; icon: string }[] = [
  { format: "csv", label: "Download CSV", icon: "fa-file-csv" },
  { format: "xlsx", label: "Download Excel", icon: "fa-file-excel" },
];

const TableV2ExportMenu = <TData extends RowData>({
  table,
  options,
}: {
  table: TableV2Instance<TData>;
  options: TableV2ExportOptions<TData>;
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const run = async (format: ExportFormat) => {
    setIsExporting(true);
    try {
      await exportTable(table, format, options);
    } catch {
      Toast({ type: "error", message: "Export failed. Please try again." });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <DropDown direction="down">
      <DropDown.Toggle testId="table-v2-export" disabled={isExporting}>
        <TableV2IconButton
          icon={
            isExporting ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-download"
          }
          label="Export"
          disabled={isExporting}
          onClick={() => undefined}
        />
      </DropDown.Toggle>
      <DropDown.Menu>
        {FORMATS.map(({ format, label, icon }) => (
          <DropDown.Item
            key={format}
            value={format}
            onClick={() => run(format)}
          >
            <i className={`fa-solid ${icon}`} style={{ width: 20 }} />
            {label}
          </DropDown.Item>
        ))}
      </DropDown.Menu>
    </DropDown>
  );
};

export default TableV2ExportMenu;
